import React, { useEffect, useState, useMemo } from 'react';
import { Card, Tag } from 'antd';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import CollectionSpot from '../CollectionSpot';
import {
    orderTopCollectionSpots,
    isSpotFromSources,
} from 'utils/collection-spot-utils.js';
import './style.css';

const SortableItem = SortableElement(
    /**
     * @param {Object} props
     * @param {CollectionSpot} props.spot
     * @param {Source[]} props.filterBySources
     */
    ({ spot, filterBySources }) => (
        <CollectionSpot
            collectionSpot={spot}
            isDimmed={!isSpotFromSources(spot, filterBySources)}
        />
    ),
);

const SortableList = SortableContainer(
    /**
     * @param {Object} props
     * @param {CollectionSpot[]} props.items
     * @param {Source[]} props.filterBySources
     */
    ({ items, filterBySources }) => {
        return (
            <div className="collection__content-spots">
                {items.map((spot, index) => (
                    // @ts-ignore
                    <SortableItem
                        key={`item-${spot.id}`}
                        index={index}
                        spot={spot}
                        filterBySources={filterBySources}
                    />
                ))}
            </div>
        );
    },
);

/**
 *
 * @param {Object} props
 * @param {TopCollection} props.collection
 * @param {Source[]} props.filterBySources
 */
function TopCollection({ collection, filterBySources }) {
    const orderedSpots = useMemo(
        () => orderTopCollectionSpots(collection.spots),
        [collection.spots],
    );
    const [spotsToShow, setSpotsToShow] = useState(orderedSpots);

    useEffect(() => {
        setSpotsToShow(orderedSpots);
    }, [orderedSpots]);

    return (
        <div className="collection top-collection">
            <Card
                bodyStyle={{ padding: 0 }}
                headStyle={{ paddingLeft: 16 }}
                title={
                    <div className="collection__title">
                        <div className="collection__header-title">
                            {topCollectionName(collection.name)}

                            {!!spotsToShow?.length && (
                                <div className="ml-s">
                                    <Tag>{spotsToShow?.length} Spots</Tag>
                                </div>
                            )}
                        </div>
                    </div>
                }
            >
                <div className="collection__content">
                    {/* 
                    // @ts-ignore */}
                    <SortableList
                        items={spotsToShow}
                        filterBySources={filterBySources}
                        distance={Number.MAX_SAFE_INTEGER}
                        axis="xy"
                        helperClass="collection-spot__dragging"
                        onSortEnd={() => undefined}
                    />
                </div>
            </Card>
        </div>
    );
}

function topCollectionName(type) {
    switch (type) {
        case 'EAT_DRINK':
            return 'Top Spots to Eat & Drink';
        case 'SEE_DO':
            return 'Top Things to See & Do';
        case 'STAY':
            return 'Top Places to Stay';
        case 'TRAVEL_TRANSPORTATION':
            return 'Travel & Transportation';
        default:
            return type;
    }
}

export default TopCollection;
